import React from 'react';
import { getEnviroment } from "../../../lib/utils.es6";
import { getPartnerGuid, getAuthorizationToken } from '../../../lib/access.es6';


class PolicyV2 extends React.Component {

  render() {


    const partnerGuid = getPartnerGuid();
    const source = "aspin";
    const environment = getEnviroment();




    const partnerConfigs = {
      'omu_posbank': {
        staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
        production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
        partnerParam: "omu_posbank"
      },
      'om_lions': {
        staging: "https://ipp-om-uganda-gle.staging.aspin-inclusivity.com",
        production: "https://ipp-om-uganda-gle.inclusivity-aspin.com",
        partnerParam: "om_lions"
      },
      'omu_flp': {
        staging: "https://ipp-om-uganda-flp.staging.aspin-inclusivity.com",
        production: "https://ipp-om-uganda-flp.inclusivity-aspin.com",
        partnerParam: "omu_flp"
      }
    };

    const currentPartnerConfig = partnerConfigs[partnerGuid];

    console.log("currentPartnerConfig", currentPartnerConfig.partnerParam);
    console.log("partnerGuid", partnerGuid);
    if (!currentPartnerConfig) {
      return (
        <section style={{ margin: "30px", color: "red" }}>
          <p style={{ color: "red" }}>Invalid partner configuration.</p>
        </section>
      );
    }

    const baseUrl = environment === "prod" ? currentPartnerConfig.production : currentPartnerConfig.staging;
    const bearerToken = getAuthorizationToken();
    const host_base_url = window.location.origin;
    const policyNumber = this.props.params && this.props.params.policy_number;
    const iframeSrc = `${baseUrl}/?partner=${currentPartnerConfig.partnerParam}&source=${encodeURIComponent(source)}&bearer_token=${encodeURIComponent(bearerToken)}&host_base_url=${encodeURIComponent(host_base_url)}&environment=${encodeURIComponent(environment)}${policyNumber ? `&mode=amend&policy_number=${encodeURIComponent(policyNumber)}` : ''}`;

    console.log('iframeSrc: ', iframeSrc)
    console.log('baseUrl: ', baseUrl);
    console.log('environment: ', environment);
    console.log('partnerGuid: ', partnerGuid);

    return (
      <>
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Insurance Quote"
          ></iframe>
        </section>
      </>
    );
  }
}
export default PolicyV2;